// extracted by mini-css-extract-plugin
export default {"select":"base-select_select__mx4sT"};